import { computed, isRef, ref } from 'vue';
/**
 * Creates a readonly ref from various input types.
 *
 * @template T The type of value to be contained in the returned ref
 * @param param The input value, which can be:
 *             - A function that returns a value (converted to computed)
 *             - An existing ref (returned as-is)
 *             - A direct value (wrapped in a new ref)
 * @returns A readonly ref containing the value
 *
 * @example
 * ```ts
 * // From a direct value
 * const directRef = makeRef(42);
 *
 * // From a function (becomes computed)
 * const computedRef = makeRef(() => someValue * 2);
 *
 * // From an existing ref (returned as-is)
 * const existingRef = ref(10);
 * const sameRef = makeRef(existingRef);
 * ```
 */
export function makeRef(param) {
    if (isRef(param)) {
        return param;
    }
    if (typeof param === 'function') {
        return computed(param);
    }
    return ref(param);
}
//# sourceMappingURL=makeRef.js.map